import { toastsManager } from "@gusarov-studio/rubik-ui";
import { toastTypes } from "./toastTypes";
import { DeleteResourceToastContainer } from "../resources/containers/DeleteResourceToastContainer";

function initialize() {
  toastsManager.register(toastTypes.DELETE_RESOURCE, DeleteResourceToastContainer);
}

export { initialize };
